export function modal() {

    async function openModal(slug) {
        const locale = document.documentElement.lang || 'ru'

        const response = await fetch(
            `/${locale === 'ru' ? '' : `${locale}/`}modal-pages/${slug}`
        )
        const page = await response.json()
        window.dispatchEvent(
            new CustomEvent("page-modal:open", {
                detail: page
            })
        )
    }
    function handleLinkClick(event, item) {
        if (!item.modalPage) {
            return
        }
        event.preventDefault()
        openModal(item.slug)
    }

    return {
        openModal,
        handleLinkClick
    }
}